export const devicePermissions = {
  Siren: {
    Read: "deviceSirenCanRead"
  }
};
